import script from "./VGoalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VGoalCard.vue?vue&type=script&setup=true&lang=ts"

import "./VGoalCard.vue?vue&type=style&index=0&id=a97d4388&lang=scss"

const __exports__ = script;

export default __exports__